import { useCallback } from 'react';
import { useAssetPreview } from 'framework-asset-preview-lib/internal/shared/providers/AssetPreviewProvider';
import { useTracker } from 'framework-asset-preview-lib/internal/shared/providers/TrackerProvider';
export default function useAssetPreviewTracking() {
  const {
    tracker
  } = useTracker();
  const {
    applicationId,
    objectType,
    previewType,
    originObjectType
  } = useAssetPreview();
  const trackAssetPreviewInteraction = useCallback(eventProps => {
    if ((previewType === 'card' || previewType === 'carousel') && eventProps.action === 'open preview') {
      return;
    }
    tracker.track('assetPreviewInteraction', Object.assign({
      applicationId,
      objectType,
      originObjectType,
      previewType
    }, eventProps));
  }, [applicationId, objectType, originObjectType, previewType, tracker]);
  return {
    trackAssetPreviewInteraction
  };
}